import { createPageSlice } from "./createPageSlice";

// Server-paginated slice for the "InOpTra's Managers - Client Mappings" Master Data grid.
const managerPageSlice = createPageSlice("managerPage", {
    defaultSortBy: "name",
    defaultSortDirection: "ASC",
});

export const managerPageActions = managerPageSlice.actions;
export default managerPageSlice;
